import { z } from 'zod';

export const PaymentMethodSchema = z.enum(['paddle']);

export type PaymentMethod = z.infer<typeof PaymentMethodSchema>;
